import { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import { FiDownload, FiBriefcase, FiAward, FiCpu } from "react-icons/fi";
import perfil from "../img/perfil.webp";
import curriculo from "../arquivos/curriculo-jonathan-rianelli-v2.pdf";
import "../styles/sobre.scss";

export default function Sobre() {
  useEffect(() => {
    // Inicializa o ScrollReveal
    const scrollReveal = ScrollReveal({
      origin: "bottom",
      distance: "30px",
      duration: 700,
      reset: false,
    });

    // Aplica a animação nos elementos com a classe 'fade-up'
    scrollReveal.reveal(".fade-up", {
      interval: 200,
    });
  }, []);

  return (
    <div className="sobre-wrapper">
      <section id="sobre">
        <div>
          <img
            src={perfil}
            alt="Jonathan Rianelli - Desenvolvedor Web"
          />
        </div>

        <div>
          <div className="status-badge fade-up">
            <span className="status-dot" />
            Disponível para projetos
          </div>

          <h2 className="fade-up">Jonathan Rianelli</h2>

          <h3 className="fade-up">Desenvolvedor FullStack</h3>

          <p className="fade-up">
          Desenvolvedor FullStack especializado em criar aplicações web robustas e automações corporativas. Formado em Análise e Desenvolvimento de Sistemas, construo soluções completas utilizando tecnologias como <strong>React</strong>, <strong>Node.js</strong>, <strong>MySQL</strong> e <strong>PostgreSQL</strong>. Com mais de 4 anos de experiência, desenvolvo desde sistemas de gestão interna até fluxos avançados de automação com <strong>Python</strong> e <strong>n8n</strong>, unindo estética limpa, alta performance e código escalável.
          </p>

          <div className="fade-up" id="btnBox">
            <a
              href={curriculo}
              download="Currículo Jonathan Rianelli de Oliveira"
              id="btn"
            >
              <FiDownload className="btn-icon" />
              Baixar Currículo
            </a>
          </div>
        </div>
      </section>

      <div className="sobre-destaques fade-up">
        <div className="destaque-card">
          <FiBriefcase className="destaque-icon" />
          <div className="destaque-info">
            <span className="destaque-numero">4+</span>
            <span className="destaque-label">Anos de experiência</span>
          </div>
        </div>
        <div className="destaque-card">
          <FiAward className="destaque-icon" />
          <div className="destaque-info">
            <span className="destaque-numero">ADS</span>
            <span className="destaque-label">Formação superior</span>
          </div>
        </div>
        <div className="destaque-card">
          <FiCpu className="destaque-icon" />
          <div className="destaque-info">
            <span className="destaque-numero">FullStack</span>
            <span className="destaque-label">Soluções completas</span>
          </div>
        </div>
      </div>
    </div>
  );
}